<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid card pt-2 pb-3 justify-content-between">
          <div class="col">
            <div class="">
              <div class="text-3xl font-bold mt-2">Reports</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-12 comp-grid">
            <div class="">
              <div :class="{ card: !isSubPage }" class="">
                <div class="q-pa-md">
                  <div class="surface-100 p-3 font-bold text-md">
                    Source of Complaint
                  </div>
                  <div class="text-500"></div>
                  <hr />
                  <div class="row q-col-gutter-sm">
                    <div class="col">
                      <api-data-source
                        api-path="components_data/barchart_sourceofcomplaint"
                      >
                        <template v-slot="req">
                          <div class="flex justify-content-start">
                            <div
                              v-for="(data, i) in req.response.datacount"
                              :key="i"
                              class=""
                            >
                              <Chip
                                :label="data.label + ': ' + data.count"
                                class="mr-2 bg-cyan-100 font-bold"
                              />
                            </div>
                          </div>
                          <hr />
                          <div style="position: relative; text-align: center">
                            <div class="text-center p-3" v-if="req.loading">
                              <ProgressSpinner
                                style="width: 30px; height: 30px"
                              />
                            </div>
                            <vue-chart
                              :chart-data="req.response"
                              chart-type="bar"
                            ></vue-chart>
                          </div>
                        </template>
                      </api-data-source>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-12 comp-grid">
            <div class="">
              <div :class="{ card: !isSubPage }" class="">
                <div class="q-pa-md">
                  <div class="surface-100 p-3 font-bold text-md">
                    Type of Complaint
                  </div>
                  <div class="text-500"></div>
                  <hr />
                  <div class="row q-col-gutter-sm">
                    <div class="col">
                      <api-data-source
                        api-path="components_data/barchart_typeofcomplaints"
                      >
                        <template v-slot="req">
                          <div class="grid justify-content-start">
                            <div
                              v-for="(data, i) in req.response.datacount"
                              :key="i"
                              class=""
                            >
                              <Chip
                                :label="data.label + ': ' + data.count"
                                class="mr-2 mb-2 bg-cyan-100 font-bold"
                              />
                            </div>
                          </div>
                          <hr />
                          <div style="position: relative; text-align: center">
                            <div class="text-center p-3" v-if="req.loading">
                              <ProgressSpinner
                                style="width: 30px; height: 30px"
                              />
                            </div>
                            <vue-chart
                              :chart-data="req.response"
                              chart-type="bar"
                              :gridlines="false"
                            ></vue-chart>
                          </div>
                        </template>
                      </api-data-source>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-12 md:col-12 comp-grid">
            <div class="">
              <div :class="{ card: !isSubPage }" class="">
                <div class="q-pa-md">
                  <div class="surface-100 p-3 font-bold text-md">
                    Status of Complaint
                  </div>
                  <div class="text-500"></div>
                  <hr />
                  <div class="row q-col-gutter-sm">
                    <div class="col">
                      <api-data-source
                        api-path="components_data/barchart_statusofcomplaint"
                      >
                        <template v-slot="req">
                          <div class="flex justify-content-start">
                            <div
                              v-for="(data, i) in req.response.datacount"
                              :key="i"
                              class=""
                            >
                              <Chip
                                :label="data.label + ': ' + data.count"
                                class="mr-2 bg-cyan-100 font-bold"
                              />
                            </div>
                          </div>
                          <hr />
                          <div style="position: relative; text-align: center">
                            <div class="text-center p-3" v-if="req.loading">
                              <ProgressSpinner
                                style="width: 30px; height: 30px"
                              />
                            </div>
                            <vue-chart
                              :chart-data="req.response"
                              chart-type="bar"
                            ></vue-chart>
                          </div>
                        </template>
                      </api-data-source>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { useApp } from "@/composables/app.js";
import VueChart from "@/components/VueCharts.vue";
const props = defineProps({
  pageName: {
    type: String,
    default: "reports",
  },
  routeName: {
    type: String,
    default: "reports",
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const pageReady = ref(true);
</script>
<style scoped></style>
